/* eslint-disable linebreak-style */
const productList = document.querySelector('.boost-sd__filter-product-list.boost-sd__filter-product-list--ready');
const OPENING_CLASS = 'js-isOpening';

if (productList) {

    const config = { childList: true };
    const BOOST_BLUR_BACKGROUND = '.boost__blur-background';

    const callback = (mutationList, observer) => {
        for (const mutation of mutationList) {
            if (mutation.target === productList) {
                const boostBlurBackground = document.querySelector(BOOST_BLUR_BACKGROUND);
                document.querySelectorAll('.boost-sd__filter-option-label').forEach(button => {

                    button.addEventListener('click', () => {

                        if (button.classList.contains(OPENING_CLASS)) {
                            button.classList.remove(OPENING_CLASS);
                            boostBlurBackground.style.display = 'none';
                        } else {
                            document.querySelectorAll(`.${OPENING_CLASS}`).forEach(button => {
                                button.classList.remove(OPENING_CLASS);
                            });
                            button.classList.add(OPENING_CLASS);
                            boostBlurBackground.style.display = 'block';
                        }
                    });
                });

                const horizontalFilterTree = document.querySelector('.boost-sd__filter-tree-horizontal');
                const applyButtons = horizontalFilterTree.querySelectorAll('.boost-sd__button--apply');
                const clearButtons = horizontalFilterTree.querySelectorAll('.boost-sd__button--clear');

                applyButtons.forEach(button => {

                    button.addEventListener('click', () => {
                        document.querySelectorAll(`.${OPENING_CLASS}`).forEach(button => {
                            button.classList.remove(OPENING_CLASS);
                        });
                        boostBlurBackground.style.display = 'none';
                    });
                });

                clearButtons.forEach(button => {

                    button.addEventListener('click', () => {
                        document.querySelectorAll(`.${OPENING_CLASS}`).forEach(button => {
                            button.classList.remove(OPENING_CLASS);
                        });
                        boostBlurBackground.style.display = 'none';
                    });
                });

                // Add event listener to the document to capture all clicks
                document.addEventListener('click', (event) => {
                    // Get the target element of the click event
                    var target = event.target;

                    // Check if the target element or any of its parents have the specified classes
                    var isInsideSpecifiedElement = target.closest('.boost-sd__filter-option-label, .boost-sd__filter-option-itemwrapper--horizontal');

                    // Check if the target element does not have the specified classes
                    if (!isInsideSpecifiedElement) {
                        document.querySelectorAll(`.${OPENING_CLASS}`).forEach(button => {
                            button.classList.remove(OPENING_CLASS);
                        });
                        boostBlurBackground.style.display = 'none';
                    }
                });

                // Promo Card
                const promoCardData = window.collectionPromoCard;
                const promoCardElement = document.querySelector('.page-section--collection-driver');

                if (!promoCardData || !promoCardElement) return false;

                if (promoCardData.title) promoCardElement.querySelector('.collection-driver__title').textContent = promoCardData.title;
                if (promoCardData.button_link) promoCardElement.querySelector('.collection-driver__link').href = promoCardData.button_link;
                if (promoCardData.image) promoCardElement.querySelector('.background-image').src = promoCardData.image;
                if (promoCardData.button_label) {
                    const buttonDiv = promoCardElement.querySelector('.collection-driver__button');
                    const iconWrapper = buttonDiv.querySelector('.button__icon-wrapper');
                    const textNode = document.createTextNode(promoCardData.button_label);
                    buttonDiv.insertBefore(textNode, iconWrapper.nextSibling);
                }

                promoCardElement.style.display = 'block';
            }
        }
    };

    const observer = new MutationObserver(callback);

    try {
        observer.observe(productList, config);
    } catch (error) {};
}
